export default __webpack_public_path__ + "static/media/basic-partner.1c4809b3.svg";